export default __webpack_public_path__ + "static/media/tick-icon-white.55d564c1.svg";